import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { BsFileEarmarkExcelFill } from "react-icons/bs";

const DownloadExcelFromData = ({
  data = [],
  columnOrder = [],
  fileName = "download",
}) => {
  const handleDownload = () => {
    if (!Array.isArray(data) || data.length === 0) {
      console.warn("No data available to export.");
      return;
    }

    const formattedData = data.map((item) => {
      const row = {};
      columnOrder.forEach((key) => {
        row[key] = item[key] ?? ""; // Keep order & fill empty if not exist
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData, {
      header: columnOrder,
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <div className="d-flex justify-content-end">
      <button
        onClick={handleDownload}
        className="btn btn-sm btn-outline-success d-flex align-items-end gap-2"
      >
        <BsFileEarmarkExcelFill />
        Download Excel
      </button>
    </div>
  );
};

export default DownloadExcelFromData;
